import React from 'react';
import DevLogin from '@boyuai/dev-login';

export default function PageLogin() {
    return <DevLogin />;
}
